import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import { UrlObject } from "url";

export default function BreadcrumbElement(p: {
  params: string[];
  href: UrlObject;
}) {
  return <BreadcrumbLink href={p.href}>Element</BreadcrumbLink>;
}
